<script>
    import VStepperContent from 'vuetify/es5/components/VStepper/VStepperContent';

    let merge = require('lodash.merge');

    export default {
        //do not set the name - it will break the integration with vuetify stepper
        extends: VStepperContent,
        props: [
            'route',
        ],
        data(){
            return {
                active: false,
            };
        },
        computed: {
            parentWrapper() {
                let me = this;
                return {
                    extends: VStepperContent,
                    data() {
                        return {
                            active: false,
                        };
                    },
                    props: {
                        step: {
                            default: me._props.step,
                        },
                    },
                    mounted() {
                        me.$refs = merge(me.$refs, this.$refs);
                    },
                    watch: {
                        active(val) {
                            me.active = val;
                        },
                    },
                };
            },
        },
    };
</script>